<template>
  <WdsText class="tw-truncate" :text="date" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const frag = graphql(`
  fragment JobShareCreatedAtColumn on JobShare {
    id
    createdAt
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))
const { date } = useDate(column.value.createdAt)
</script>
